import React, { useEffect, useState, useRef } from "react";
import Modal from "react-modal";
import styles from "./style.module.css";
import Header from "../partials/header/header";
import Loader from "../partials/Loader";
import { useSelector } from "react-redux";
import "sweetalert2/dist/sweetalert2.min.css";
import { toast } from "react-toastify";
import { Link, useNavigate, useParams } from "react-router-dom";
import backgroundMusic from "../../assets/audio/start_question.mp3";
import backgroundMusicClick from "../../assets/audio/click.mp3";
import backgroundMusicLose from "../../assets/audio/wahwah.mp3";
import backgroundMusicWin from "../../assets/audio/win.mp3";
import { Record } from "../question/Record";
import io from "socket.io-client";
import DownloadRec from "../../assets/new-design/download.png";
import FinishGame from "../../assets/new-design/re-start.png";
import ShareButtons from "./ShareButtons";
const url = process.env.REACT_APP_APP_BACK_URL;
const STREAM_SOCKET_URL =
  process.env.REACT_APP_STREAMIN_SOCKET_URL ||
  "wss://live.camera.streaming.lok3r.net";

const toDynamicStreamUrl = (rtspUrl) =>
  `${STREAM_SOCKET_URL.replace(/\/$/, "")}/stream/url/dynamic?url=${encodeURIComponent(rtspUrl)}`;
const socket = io.connect(url);

const isValidPlayerId = (value) =>
  typeof value === "string" &&
  value.length === 24 &&
  value !== "null" &&
  value !== "undefined";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

const DashboardScr = ({ recordingStarting = "0" }) => {
  let navigate = useNavigate();
  const streaming_url = process.env.REACT_APP_STREAMIN_SOCKET_URL ;
  const { id } = useParams()
  let slug = "invid";
  const [loader, setLoader] = useState(true);
  const [isFloating, setIsFloating] = useState(false);
  const [isCallFloating, setIsCallFloating] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisplay, setIsDisplay] = useState(false);
  const [isLockerOpen, setIsLockerOpen] = useState(false);
  const [backgroundAudio] = useState(new Audio(backgroundMusic));
  const [backgroundAudioClick] = useState(new Audio(backgroundMusicClick));
  const [backgroundAudioLose] = useState(new Audio(backgroundMusicLose));
  const [backgroundAudioWin] = useState(new Audio(backgroundMusicWin));
  const [isGameEnd, setIsGameEnd] = useState(false);
  const [prize, setPrize] = useState("");
  const [winnername, setwinnername] = useState("");
  const [selectedUsers, setselectedUsers] = useState([]);
  const [getLocker, setLocker] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLocker, setselectedLocker] = useState("");
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const [isModalOpen4, setIsModalOpen4] = useState(false);
  const [isReadyModalOpen, setIsReadyModalOpen] = useState(false);
  const [recordingShow, setRecordingShow] = useState(false);
  const [winnerLocker, setWinnerLocker] = useState();
  const [localPlayer, setLocalPlayer] = useState();
  const [localPlayersDetail, setLocalPlayersDetail] = useState();
  const [playerData, setPlayerData] = useState();
  const [currentPlayer, setCurrentPlayer] = useState();
  const [playersDetail, setPlayersDetail] = useState();
  const [gamePlayer, setGamePlayer] = useState();
  const [modalButton, setModalButton] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const playerFromQuery = queryParams.get("p");
  const [activePlayerId, setActivePlayerId] = useState(() =>
    isValidPlayerId(playerFromQuery) ? playerFromQuery : null
  );
  const position = parseInt(queryParams.get("position")) || 0;
  const [seletedPlayers, setSeletedPlayers] = useState([]);
  const [relayNumber, setRelayNumber] = useState();
  const [download, setDownload] = useState(false);
  const [disablelocker, setdisablelocker] = useState(true);
  const [videoSrc, setVideoSrc] = useState(null);
  const [recordingLoading, setRecordingLoading] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [streamPlayerUrl, setStreamPlayerUrl] = useState(null);
  const pendingLockerRef = useRef({ lockerId: null, overlayRelay: null });
  let count = 0;

  // Overlay 1–16 maps to ls-001…ls-016. Lockers 11–16 use relay 1–6 on port 8997.
  const getLockerByOverlayRelay = (overlayRelay) => {
    const number = `ls-${String(overlayRelay).padStart(3, "0")}`;
    return getLocker.find((locker) => locker.number === number);
  };

  const getOverlayRelayFromLocker = (locker) => {
    if (!locker?.number) return Number(locker?.relay);
    const match = String(locker.number).match(/ls-(\d+)$/i);
    return match ? parseInt(match[1], 10) : Number(locker.relay);
  };
  useEffect(() => {
    return () => {
      // Clean up: Stop the background music when the component unmounts
      backgroundAudio.pause();
      backgroundAudio.currentTime = 0;
    };
  }, [backgroundAudio]);
  useEffect(() => {
    if (!recordingShow) {
      return;
    }

    if (timeRemaining <= 0) {
      setRecordingLoading(true);
      return;
    }

    const timer = setInterval(() => {
      setTimeRemaining((prevTime) => Math.max(0, prevTime - 1));
    }, 1000);

    return () => clearInterval(timer);
  }, [timeRemaining, recordingShow]);
  const handleBoxClick = (locker_number) => {};

  useEffect(() => {
    siteLockers();
  }, []);

  useEffect(() => {
    const fetchActiveStream = async () => {
      try {
        const response = await fetch(`${url}/api/streaming/active`, {
          mode: "cors",
          method: "GET",
        });
        const json = await response.json();

        if (json.success && json.source_url) {
          setStreamPlayerUrl(toDynamicStreamUrl(json.source_url));
        }
      } catch (error) {
        console.warn("Active stream fetch failed.", error);
      }
    };

    fetchActiveStream();
  }, []);

  const handleVideoClick = () => {
    const { width } = getWindowDimensions();
    const surfaceTabletWidth = 768;

    if (width <= surfaceTabletWidth) {
      setIsFloating(!isFloating);
      setIsCallFloating(false);
    } else {
      setIsFloating(false);
    }
  };

  useEffect(() => {
    if (!streamPlayerUrl) {
      return;
    }

    const canvas = document.getElementById("canvas");
    if (!canvas) {
      return;
    }

    const script = document.createElement("script");
    script.src =
      "https://cdn.jsdelivr.net/npm/rtsp-relay@1.7.0/browser/index.js";
    script.async = true;
    script.type = "text/javascript";
    script.onload = () => {
      if (typeof loadPlayer !== "function") {
        return;
      }
      /* eslint-disable no-undef */
      loadPlayer({
        url: `${streaming_url}/stream/url/5`, 
        canvas,
      });
      /* eslint-enable no-undef */
    };
    script.onerror = () => {
      console.warn("Stream player script failed to load.");
    };
    document.head.appendChild(script);
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [streamPlayerUrl]);

  useEffect(() => {
    if (isGameEnd) {
      backgroundAudio.pause();
      backgroundAudio.currentTime = 0;
    }
  }, [isGameEnd, backgroundAudio]);
  useEffect(() => {
    winnerLockers();
    getPlayers();
  }, []);
  useEffect(() => {
    socket.emit("gameID", id);
    socket.on("showCashPrize", (data) => {
      setIsModalOpen2(true);
      if (parseInt(recordingStarting) > 1) {
        setTimeout(() => {
          // setIsModalOpen3(false);
          count = 0;
          getRecordings();
        }, 6000);
      }
      setselectedLocker(data.locker);
      setPrize(data.prize);
      setwinnername(data.name);
      setIsModalOpen4(false);
      setdisablelocker(false);
    });
    socket.on("showMemesPrize", (data) => {
      setIsModalOpen3(true);
      if (parseInt(recordingStarting) > 1) {
        setTimeout(() => {
          // setIsModalOpen3(false);
          count = 0;
          getRecordings();
        }, 6000);
      }

      setselectedLocker(data.locker);
      setPrize(data.prize);
      setwinnername(data.name);
      setIsModalOpen4(false);
      setdisablelocker(false);
      console.log("check this :", disablelocker);
    });
  }, [recordingStarting]);
  // get all locker questions
  const userPrize = async () => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      const response = await fetch(
        `${url}/api/multiplayer/winner/locker/status/${id}`,
        {
          mode: "cors",
          method: "GET",
          headers: headers,
        }
      );
      const json = await response.json();
      if (json.success) {
        backgroundAudio.pause();
        backgroundAudio.currentTime = 0;
      } else {
        toast.error(json.error);
        navigate("/");
      }
    } catch (error) {
      console.error(error);
    }
  };
  // get selected player to show user prizes
  const getPlayers = async () => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");

      const response = await fetch(
        `${url}/api/multiplayer/get/loser/player/${id}`,
        {
          mode: "cors",
          method: "GET",
          headers: headers,
        }
      );
      const json = await response.json();

      if (json.success) {
        setSeletedPlayers(json.selectedPlayers);
        setselectedUsers(json.selectedUsers);
        setLocalPlayer(json.localPlayers);
        setLocalPlayersDetail(json.localPlayerData);
        setPlayerData(json.players);

        if (!activePlayerId && json.players?.length) {
          const mainPlayer = json.players.find((p) => p.type === "main");
          const localPlayer = json.players.find((p) => p.type === "local");
          const resolvedPlayerId =
            mainPlayer?._id || localPlayer?._id || json.players[0]?._id;

          if (resolvedPlayerId) {
            setActivePlayerId(resolvedPlayerId);
          }
        }

        setIsModalOpen4(true);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const getRecordings = async () => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      const response = await fetch(
        `${url}/api/multiplayer/get/player/recording/${id}`,
        {
          mode: "cors",
          method: "GET",
          headers: headers,
        }
      );
      const json = await response.json();
      if (json.success) {
        setIsModalOpen2(false);
        setIsModalOpen3(false);
        setRecordingShow(true);
        setTimeRemaining(7);
        count = parseInt(count) + 1;
        if (json.recording === "no") {
          // socket.emit("stopRecording", {
          //   player: seletedPlayers,
          // });
          setTimeout(() => {
            if(count<3){
              getRecordings();
            }
          }, 1000);
        } else if (
          parseInt(recordingStarting) > 2 &&
          json.isRecordingStop === "yes"
        ) {
        } else if (
          json.recording !== "no" &&
          parseInt(recordingStarting) <= 2
        ) {
          setVideoSrc(json.recording);
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const getCurrentPlayer = async (playerId) => {
    if (!isValidPlayerId(playerId)) {
      return;
    }

    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");

      const response = await fetch(
        `${url}/api/multiplayer/get/current/player/${playerId}`,
        {
          mode: "cors",
          method: "GET",
          headers: headers,
        }
      );
      const json = await response.json();

      if (json.success) {
        setCurrentPlayer(json.currentPlayer);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const getGamePlayer = async (playerId) => {
    if (!isValidPlayerId(playerId)) {
      return;
    }

    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");

      const response = await fetch(
        `${url}/api/multiplayer/get/game/player/${id}/${playerId}`,
        {
          mode: "cors",
          method: "GET",
          headers: headers,
        }
      );
      const json = await response.json();
      if (json.success && json.gamePlayer?._id) {
        setGamePlayer(json.gamePlayer._id);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    if (!activePlayerId) {
      return;
    }

    getCurrentPlayer(activePlayerId);
    getGamePlayer(activePlayerId);
  }, [activePlayerId]);

  useEffect(() => {
    setLoader(true);
    const timerId = setTimeout(() => {
      setLoader(false);
      userPrize();
    }, 5000); // 3000 milliseconds = 3 seconds
    return () => clearTimeout(timerId);
  }, []);

  // get all site
  const siteLockers = async () => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      const response = await fetch(`${url}/api/sites/lockers/${slug}`, {
        mode: "cors",
        method: "GET",
        headers: headers,
      });
      const json = await response.json();

      if (json.success) {
        setLocker(json.lockers);
        setselectedLocker("");
        setIsDisplay(true);
      } else {
        toast.error(json.error);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  // open locker
  const openLocker = async (locker_id) => {
    let state = "2";
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Access-Control-Allow-Credentials", "true");
    setIsLockerOpen(true);
    setIsLoading(true);

    const response = await fetch(`${url}/api/prizes/open/show/locker`, {
      mode: "cors",
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        id: id,
        locker_id: locker_id,
        state: state,
      }),
    });

    setIsLockerOpen(false);
    const json = await response.json();
    if (json.success) {
      // socket.emit("stopRecording", seletedPlayers);
      if (json.prizes.type === "money") {
        socket.emit("cashPrize", {
          player: seletedPlayers,
          locker: locker_id,
          prize: json.prizes.amount,
          name: winnerLocker ? winnerLocker.name : "",
        });

        setIsModalOpen2(true);
        if (parseInt(recordingStarting) > 1) {
          setTimeout(() => {
            getRecordings();
          }, 6000);
        }

        setPrize(json.prizes.amount);
        backgroundAudioWin.play();
      } else {
        socket.emit("memePrize", {
          player: seletedPlayers,
          locker: locker_id,
          prize: json.prizes.memes,
          name: winnerLocker ? winnerLocker.name : "",
        });

        setIsModalOpen3(true);
        if (parseInt(recordingStarting) > 1) {
          setTimeout(() => {
            getRecordings();
          }, 6000);
        }
        setPrize(json.prizes.memes);
        backgroundAudioLose.play();
      }
    } else {
      toast.error(json.error);
    }

    setIsLoading(false);
    siteLockers();
  };

  const backtohome = () => {
    if (activePlayerId) {
      localStorage.removeItem(activePlayerId);
    }
    backgroundAudioLose.pause();
    backgroundAudioLose.currentTime = 0;
    backgroundAudioWin.pause();
    backgroundAudioWin.currentTime = 0;
    navigate("/");
  };

  const handleConfirm = () => {
    const pending = pendingLockerRef.current;
    const lockerId =
      pending.lockerId ||
      getLockerByOverlayRelay(pending.overlayRelay)?._id ||
      getLockerByOverlayRelay(relayNumber)?._id ||
      selectedLocker;

    if (!lockerId) {
      toast.error("Locker could not be identified. Please try again.");
      return;
    }

    if (parseInt(recordingStarting) > 1) {
      socket.emit("stopRecording", {
        player: seletedPlayers,
      });
    }
    openLocker(lockerId);
    socket.emit("closeModal", {
      gamePlayers: gamePlayer,
    });
    setIsReadyModalOpen(false);
    pendingLockerRef.current = { lockerId: null, overlayRelay: null };
  };

  const displayOpen = (overlayRelay) => {
    const locker = getLockerByOverlayRelay(overlayRelay);

    if (!locker) {
      toast.error(`Locker ${overlayRelay} not found.`);
      return;
    }

    pendingLockerRef.current = {
      lockerId: locker._id,
      overlayRelay,
    };

    backgroundAudioClick.play();
    socket.emit("openModal", {
      gamePlayers: gamePlayer,
      relay: overlayRelay,
      id: locker._id,
    });
    setIsReadyModalOpen(true);
    setselectedLocker(locker._id);
    setRelayNumber(overlayRelay);
    setModalButton(true);
  };

  useEffect(() => {
    const onShowOpenModal = (data) => {
      const locker = data?.id
        ? getLocker.find((item) => String(item._id) === String(data.id))
        : getLockerByOverlayRelay(data?.relay);

      if (locker) {
        const overlayRelay = getOverlayRelayFromLocker(locker);
        pendingLockerRef.current = {
          lockerId: locker._id,
          overlayRelay,
        };
        setselectedLocker(locker._id);
        setRelayNumber(overlayRelay);
      } else if (data?.relay != null) {
        pendingLockerRef.current = {
          lockerId: null,
          overlayRelay: Number(data.relay),
        };
        setRelayNumber(data.relay);
      }

      setIsReadyModalOpen(true);
      setModalButton(false);
    };

    const onHideCloseModal = () => {
      setIsReadyModalOpen(false);
    };

    socket.on("showOpenModal", onShowOpenModal);
    socket.on("hideCloseModal", onHideCloseModal);

    return () => {
      socket.off("showOpenModal", onShowOpenModal);
      socket.off("hideCloseModal", onHideCloseModal);
    };
  }, [getLocker]);

  const handleDownloadClick = () => {
    setDownload(true);
  };
  const closeModal = () => {
    socket.emit("closeModal", {
      gamePlayers: gamePlayer,
    });
    setIsReadyModalOpen(false);
    setselectedLocker("");
    pendingLockerRef.current = { lockerId: null, overlayRelay: null };
    setIsModalOpen(false);
  };

  const winnerLockers = async () => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");

      const response = await fetch(
        `${url}/api/multiplayer/winners/locker/${id}`,
        {
          mode: "cors",
          method: "GET",
          headers: headers,
        }
      );

      const json = await response.json();

      if (json.success) {
        setWinnerLocker(json.winner);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const sortedUsers = selectedUsers.slice().sort((a, b) => b.score - a.score);

  const overlayCellCls = (relay) => {
    const locker = getLockerByOverlayRelay(relay);
    const classes = [styles.overlayCell];
    if (locker && selectedLocker === locker._id) {
      classes.push(styles.overlayCellSelected);
    }
    return classes.join(" ");
  };

  const LockerOverlayCell = ({
    relay,
    rowSpan,
    clickable = true,
    extraClass = "",
  }) => {
    const locker = getLockerByOverlayRelay(relay);
    if (!locker) {
      return <td rowSpan={rowSpan} className={styles.overlayCellEmpty} />;
    }

    const handleClick =
      clickable && disablelocker ? () => displayOpen(relay) : undefined;

    return (
      <td
        rowSpan={rowSpan}
        className={`${overlayCellCls(relay)} ${extraClass}`.trim()}
        onClick={handleClick}
      />
    );
  };

  return (
    <div className={styles.heading}>
      <div className={styles.pageWrap}>
        <div className={styles.streamSection}>
          <div className={styles.streamViewport}>
            <div className={styles.streamStage}>
              <canvas id="canvas" className={styles.streamCanvas} />

              <div className={styles.overlayLayer}>
                <table className={styles.lockerOverlay}>
                  <tbody>
                    <tr style={{ height: "19.66%" }}>
                      <LockerOverlayCell relay={1} rowSpan={2} />
                      <LockerOverlayCell relay={4} rowSpan={2} />
                      <LockerOverlayCell relay={7} />
                      <LockerOverlayCell relay={11} rowSpan={2} />
                      <LockerOverlayCell relay={14} rowSpan={2} />
                    </tr>
                    <tr style={{ height: "12.66%" }}>
                      <LockerOverlayCell
                        relay={8}
                        extraClass={styles.overlayCellAboveKiosk}
                      />
                    </tr>
                    <tr style={{ height: "13.66%" }}>
                      <LockerOverlayCell relay={2} rowSpan={2} />
                      <LockerOverlayCell relay={5} rowSpan={2} />
                      <td rowSpan={2} className={styles.overlayKioskMask} />
                      <LockerOverlayCell relay={12} rowSpan={2} />
                      <LockerOverlayCell relay={15} rowSpan={2} />
                    </tr>
                    <tr style={{ height: "13.66%" }} />
                    <tr style={{ height: "12.66%" }}>
                      <LockerOverlayCell relay={3} rowSpan={2} />
                      <LockerOverlayCell relay={6} rowSpan={2} />
                      <LockerOverlayCell
                        relay={9}
                        extraClass={styles.overlayCellBelowKiosk}
                      />
                      <LockerOverlayCell relay={13} rowSpan={2} />
                      <LockerOverlayCell relay={16} rowSpan={2} />
                    </tr>
                    <tr style={{ height: "19.66%" }}>
                      <LockerOverlayCell relay={10} />
                    </tr>
                  </tbody>
                </table>
              </div>

              {loader && (
                <div className={styles.streamLoader}>
                  <Loader />
                </div>
              )}
            </div>
          </div>
        </div>

        {isReadyModalOpen && (
          <div className={styles.modalBackdrop}>
            <div className={styles.modalPanel}>
              <div className="d-flex flex-row">
                <h2 className="win-heading">Ready</h2>
              </div>
              <div className={styles.modalPanelInner}>
                <h2 className="text-center m-0">
                  Do you want to open locker no{" "}
                  <span className="badge bg-warning">{relayNumber}</span> ?
                </h2>
                {modalButton && (
                  <div className="d-flex justify-content-center align-items-center flex-row gap-3">
                    <button
                      className="btn btn-modal w-auto px-4"
                      onClick={handleConfirm}
                    >
                      Yes
                    </button>
                    <button
                      className="btn btn-modal w-auto px-4"
                      onClick={closeModal}
                    >
                      No
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {isModalOpen3 && (
          <div className="loserModal d-flex justify-content-center align-items-center">
            <div
              className="p-3 w-sm-50 h-sm-50 col-10 rounded-3"
              style={{ background: "#456e01" }}
            >
              <div className="d-flex flex-row">
                <h2 className="win-heading">
                  {winnerLocker && winnerLocker._id === activePlayerId
                    ? "You"
                    : winnername}{" "}
                  Lose
                </h2>
              </div>
              <div
                className="p-4 rounded-2 w-sm-25 d-flex justify-content-center align-items-center flex-column gap-3" //h-75
                style={{ background: "#7bb717" }}
              >
                {!imageError ? (
                  <img
                    width="100%"
                    height="100%"
                    className="video-area"
                    src={prize}
                    onError={() => setImageError(true)}
                  />
                ) : (
                  <div className="text-center">
                    <h6>Meme Not Found</h6>
                  </div>
                )}
                {parseInt(recordingStarting) > 1 && (
                  <div className="screen-loader video-area ">
                    <div
                      className="lds-spinner"
                      style={{ display: "flex", left: "35%" }}
                    >
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                    <div></div>
                    <h6 className="mt-5">
                      Please Wait For Screen Recording...
                    </h6>
                  </div>
                )}
                <button className="btn btn-modal w-auto" onClick={backtohome}>
                  Try Again
                </button>
                {/* <Record/> */}
              </div>
            </div>
          </div>
        )}

        {isModalOpen2 && (
          <div className="winnerModal d-flex justify-content-center align-items-center">
            <div
              className="p-3 w-sm-50 h-sm-50 col-8 rounded-3"
              style={{ background: "#456e01" }}
            >
              <div className="d-flex flex-row">
                <h2 className="win-heading">
                  {winnerLocker && winnerLocker._id === activePlayerId
                    ? "You"
                    : winnername}{" "}
                  Win
                </h2>
              </div>
              <div
                className="p-4 rounded-2 w-sm-25 d-flex justify-content-center align-items-center flex-column gap-3" //h-75
                style={{ background: "#7bb717" }}
              >
                {/* <img src={Gift} alt="gift" className="emoji-style-win" /> */}

                <div className="score-card-winner">
                  <p>${prize}</p>
                </div>
                {parseInt(recordingStarting) > 1 && (
                  <div className="screen-loader video-area ">
                    <div
                      className="lds-spinner "
                      style={{ display: "flex", left: "35%" }}
                    >
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                    <div></div>
                    <h6 className="mt-5">
                      Please Wait For Screen Recording...
                    </h6>
                  </div>
                )}
                <button
                  className="btn btn-modal w-auto mt-2"
                  onClick={backtohome}
                >
                  Play Again
                </button>
                {/* <Record/>
                 */}
              </div>
            </div>
          </div>
        )}

        {recordingShow && (
          <div>
            <div className="winnerModal d-flex justify-content-center align-items-center">
              <div
                className="p-3 w-sm-50 h-sm-50 col-10 rounded-3"
                style={{ background: "#456e01" }}
              >
                <div
                  className="p-2 rounded-2 w-sm-25 d-flex justify-content-center align-items-center flex-column gap-3" //h-75
                  style={{ background: "#7bb717" }}
                >
                  {videoSrc ? (
                    <video
                      className="video-area"
                      style={{
                        width: "100%",
                        height: "100%",
                        textAlign: "center",
                      }}
                      controls
                      src={videoSrc}
                    />
                  ) : (
                    <div className="screen-loader video-area ">
                      {parseInt(recordingStarting) > 2 ? (
                        <>
                          <h6 className="mt-2">
                            Recording has been stopped by the host.
                          </h6>
                        </>
                      ) : (
                        <>
                          {recordingLoading ? (
                            <h6 className="mt-5">
                              Something went wrong when loading recording !
                            </h6>
                          ) : (
                            <>
                              <div
                                className="lds-spinner "
                                style={{ display: "flex", left: "35%" }}
                              >
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                              </div>
                              <div></div>
                              <h6 className="mt-5">
                                Please Wait For Screen Recording...
                              </h6>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  )}

                  <div className="d-flex justify-content-center align-items-center flex-row gap-3">
                    {videoSrc && (
                      <a
                        className="btn btn-modal w-auto"
                        href={videoSrc}
                        download={videoSrc}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <img src={DownloadRec} alt="download recording" />
                      </a>
                    )}
                    {(parseInt(recordingStarting) > 2 ||
                      videoSrc ||
                      recordingLoading) && (
                      <a className="btn btn-modal w-auto" onClick={backtohome}>
                        <img src={FinishGame} alt="finish game" />
                      </a>
                    )}
                  </div>
                  {videoSrc && (
                    <ShareButtons
                      url={videoSrc}
                      title="Check out game recording!"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardScr;
